import styles from 'styles/add/Video.module.css'

export default function BlackBox ({ children }) {
    return (
        <div className={styles.blackbox}>
            {children}
        </div>
    )
}